<script lang="ts" setup>
  import { onMounted, ref } from 'vue'

  import PageLoading from '@/components/PageLoading.vue'
  import ViewTitle from '@/elements/ViewTitle.vue'
  import type { CmsPageJsonldDefaultRead } from '@/api'
  import { useGeneratedCmsPageStore } from '@/stores'
  import DevDump from '@/elements/DevDump.vue'
  import CmsLayout100 from '@/views/cms/CmsLayout100.vue'
  import CmsLayout25_25_25_25 from '@/views/cms/CmsLayout25_25_25_25.vue'
  import CmsLayout25_25_50 from '@/views/cms/CmsLayout25_25_50.vue'
  import CmsLayout33_66 from '@/views/cms/CmsLayout33_66.vue'
  import CmsLayout33_33_33 from '@/views/cms/CmsLayout33_33_33.vue'
  import CmsLayout50_25_25 from '@/views/cms/CmsLayout50_25_25.vue'
  import CmsLayout50_50 from '@/views/cms/CmsLayout50_50.vue'
  import CmsLayout66_33 from '@/views/cms/CmsLayout66_33.vue'
  import CmsLayout100_33_66 from '@/views/cms/CmsLayout100_33_66.vue'
  import CmsLayout100_50_50 from '@/views/cms/CmsLayout100_50_50.vue'
  import CmsLayout100_66_33 from '@/views/cms/CmsLayout100_66_33.vue'
  import { useRouter } from 'vue-router'

  const store = useGeneratedCmsPageStore()

  const isLoading = ref(true)

  const page = ref<CmsPageJsonldDefaultRead>()

  const router = useRouter()
  onMounted(async () => {
    const { meta } = router.currentRoute.value

    if (!meta.cms?.pageid) {
      throw new Error('Custom page not found!')
    }
    page.value = await store.fetchById(meta.cms.pageid).then((d) => d.value)
    isLoading.value = false
  })
</script>

<template>
  <div>
    <template v-if="isLoading || !page || !page.blocks">
      <PageLoading />
    </template>
    <template v-else>
      <ViewTitle :title="page.title ?? ''" />
      <CmsLayout25_25_25_25
        v-if="page.layout === '25-25-25-25'"
        :blocks="page.blocks" />
      <CmsLayout25_25_50
        v-else-if="page.layout === '25-25-50'"
        :blocks="page.blocks" />
      <CmsLayout33_66
        v-else-if="page.layout === '33-66'"
        :blocks="page.blocks" />
      <CmsLayout33_33_33
        v-else-if="page.layout === '33-33-33'"
        :blocks="page.blocks" />
      <CmsLayout50_25_25
        v-else-if="page.layout === '50-25-25'"
        :blocks="page.blocks" />
      <CmsLayout66_33
        v-else-if="page.layout === '66-33'"
        :blocks="page.blocks" />
      <CmsLayout50_50
        v-else-if="page.layout === '50-50'"
        :blocks="page.blocks" />
      <CmsLayout100
        v-else-if="page.layout === '100'"
        :blocks="page.blocks" />
      <CmsLayout100_33_66
        v-else-if="page.layout === '100_33-66'"
        :blocks="page.blocks" />
      <CmsLayout100_50_50
        v-else-if="page.layout === '100_50-50'"
        :blocks="page.blocks" />
      <CmsLayout100_66_33
        v-else-if="page.layout === '100_66-33'"
        :blocks="page.blocks" />
      <div v-else>(Unsupported template: {{ page.layout }})</div>
      <!--            <component-->
      <!--                :is="getLayout(page)"-->
      <!--                :blocks="page.blocks" />-->
      <!--            <component-->
      <!--                :is="layout"-->
      <!--                :blocks="page.blocks" />-->
      <!--            -->

      <DevDump
        v-model="page"
        header="Page" />
    </template>
  </div>
</template>
